"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*@ngInject*/
exports.default = ['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('pricelist', {
            url: '/pricelist',
            template: require('../views/pricelist.html'),
            controller: 'PricelistController',
            controllerAs: 'pricelist'
        });
    }];



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/pricelists/config/routes.js
// module id = 409
// module chunks = 0